<template>
  <div class="carousel_wrap">
    <el-carousel height="18vw" loop arrow="never" class="hidden-xs-only">
      <el-carousel-item v-for="(item, index) in childArray" @click.native="openVideo(index)" :key="index">
        <img :src="item.src" alt="" class="img_item" />
        <!-- <div class="tips_font">
          <h1>{{ item.line1 }}</h1>
          <h1>{{ item.line2 }}</h1>
        </div> -->
      </el-carousel-item>
    </el-carousel>
    <el-carousel height="50vw" loop arrow="never" class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in childArray"  @click.native="openVideo(index)"   :key="index">
        <img :src="item.src" alt="" class="img_item" />
        <!-- <div class="tips_font">
          <h1>{{ item.line1 }}</h1>
          <h1>{{ item.line2 }}</h1>
        </div> -->
      </el-carousel-item>
    </el-carousel>
   <el-dialog
    :visible.sync="needDialogVisible"
    custom-class="transparent-dialog"
    width="60%"
    background-color="#ffffff00"
    :close-on-click-modal="false"
    :show-close="true"
    @close="needclik"
  >
    <div class="video-container">
      <video ref="videoPlayer" :src="currentVideo"  controls autoplay></video>
    </div>
  </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    childArray: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      needDialogVisible: false,
      currentVideo: '',
      imgList: [
        {
          src: require('@/assets/img/banner-three.jpg'),
          line1: '产业大脑',
          line2: '赋能产业高质量发展',
        },
        // {
        //   src: require('@/assets/img/banner-two.jpg'),
        //   line1: '全面推进数字建设化改革',
        //   line2: '',
        // },
        {
          src: require('@/assets/img/banner-one.jpg'),
          line1: '全面推进数字建设化改革',
          line2: '',
        },
      ],
    }
  },

  mounted(){

  },
  methods: {
    openVideo(all) {
      console.log(all)
      if(all==1){
        this.needDialogVisible=true
       this.currentVideo='https://www.hittik.com/staticfile/MiniProgrammp4/1.mp4';
       this.$refs.videoPlayer.play();
      }
      // if(item.video==''){
      //   return
      // }else{
      //   this.currentVideo = item.video
      // }
    },
    needclik(){
       this.$refs.videoPlayer.pause();
       console.log('all')
    }
  },
  
    
}
</script>

<style lang="scss" scoped>

::v-deep .el-dialog__close

 {
   font-size: 30px;
    color: #ffffff !important;
}
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .hidden-xs-only{
margin-top: 70px;
  }
  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}
.video-container {
  width: 100%;
  height: 90%;         /* 让容器撑满弹框 */
  position: relative;
}

.video-container video {
  width: 98%;
  height: 95%;
  object-fit: cover;    /* 保持视频内容宽高比，同时填充容器 */
  display: block;       /* 避免视频元素下方空白间隙 */
}

.transparent-dialog .el-dialog {
  background-color: transparent !important; /* 弹框内容背景透明 */
  box-shadow: none !important; /* 去掉阴影 */
  overflow: hidden; /* 防止滚动条 */
  color: white; /* 默认文字白色（如果有文字） */
}

/* 弹框头部也透明 */
.transparent-dialog .el-dialog__header {
  background-color: transparent !important;
  border-bottom: none !important;
  color: white;
  position: relative;
}

/* 弹框body透明 */
.transparent-dialog .el-dialog__body {
  background-color: transparent !important;
  padding: 0;
  height: 80vh; /* 根据需要调整高度 */
}

/* 关闭按钮变白 */
.transparent-dialog .el-dialog__headerbtn {
  color: white;
  font-size: 30px;
  line-height: 30px;
  opacity: 1;
  right: 15px;
  top: 15px;
}

.transparent-dialog .el-dialog__headerbtn:hover {
  color: #ccc;
}

::v-deep .el-dialog{
  background: none!important;
 background-color: none !important;
  box-shadow: none !important;
}
::v-deep .el-dialog__header {
  border-bottom: none;
}

::v-deep .el-overlay {
  background-color: rgba(0, 0, 0, 0.7) !important;
}
</style>